import { render, staticRenderFns } from "./NamingConventions.vue?vue&type=template&id=209e6ef4&"
import script from "./NamingConventions.vue?vue&type=script&lang=js&"
export * from "./NamingConventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports